<template>
    <!-- <apexchart id="apexchart" :options="chartOptions" :series="series" type="bar" height="450"/> -->
    <div>
        <progress-overlay :Loading="Loading"></progress-overlay>
        <v-card class="ma-0 pa-0 chartCard" style="min-height:100%">
            <!--<v-toolbar color="transparent" style="height:5vh" flat dense card>-->
            <v-toolbar color="transparent" flat dense class="chartCardHeader">
                <v-toolbar-title><h4>Star Rating Measures</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <DataCountInfo :dataCountInfo="dataCountInfo.yourDataCount"
                               :dataInfoName="yourDataDataInfoName" class="dataCountInfoChip"></DataCountInfo>
                <DataCountInfo :dataCountInfo="dataCountInfo.benchmarkDataCount"
                               :dataInfoName="benchmarkDataInfoName" class="dataCountInfoChip"></DataCountInfo>
                <v-btn @click="$emit('next')" dark color="#666666" small>Next<v-icon right>navigate_next</v-icon></v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex>
                        <v-radio-group v-model="modelScoreRadios" row hide-details class="ma-1 pa-1 pl-3">
                            <template v-slot:label>
                                <div class="subheading font-weight-bold">Score View:</div>
                            </template>
                            <v-radio value="scaledMeanScore" label="Scaled Mean Score" @change="updateChart('scaledMeanScore')">
                            </v-radio>
                            <v-radio value="summaryRateScore" label="Summary Rate Score" @change="updateChart('summaryRateScore')">
                            </v-radio>
                            <v-radio value="topBoxScore" label="Top Box Score" @change="updateChart('topBoxScore')">
                            </v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex class="ma-0 mt-2 pa-0 pt-2 barChartBorder">
                        <BarChart ref="SurveyDataBarChart" :chart-data="chartData" id="SurveyDataBarChart"
                                  class="chart-container" style="position: relative; max-height:40vh; width:80vw"></BarChart>
                    </v-flex>
                    <v-flex xs12 class="categoriesDataSourceLabel;ma-0 pa-0" style="min-height:1vh">
                        <FilterSelections :tblDataFilters="tblYourDataFilters" :heading="nameDataSource"></FilterSelections>
                    </v-flex>
                    <v-flex xs12 class="categoriesDataSourceLabel; ma-0 pa-0" style="min-height:1vh">
                        <FilterSelections :tblDataFilters="tblBenchmarkFilters" :heading="nameBenchmark"></FilterSelections>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex';
    import BarChart from "./BarChart";
    import ProgressOverlay from '../_partial/ProgressOverlay'
    import FilterSelections from '../_partial/FilterSelections'
    import DataCountInfo from '../_partial/DataCountInfo'

    export default {
        components: {
            BarChart,
            ProgressOverlay,
            FilterSelections,
            DataCountInfo
        },
        //props: ['chartData'],
        data() {
            return {
                Loading: false,
                nameDataSource: "Data Source:",
                nameBenchmark: "Benchmark:",
                yourDataDataInfoName: "Your Data:",
                benchmarkDataInfoName: "Benchmark Data:"
            }
        },
        computed: {
            ...mapState({
                chartData: state => state.YourDataStore.chartData,
                Tab: state => state.AppStore.tab,
                modelYourDataFilters: state => state.CategoriesStore.modelYourDataFilters,
                tblYourDataFilters: state => state.CategoriesStore.tblYourDataFilters,
                tblBenchmarkFilters: state => state.CategoriesStore.tblBenchmarkFilters,
                dataCountInfo: state => state.YourDataStore.dataCountInfo,
            }),
            CategoriesSelectedYourData: {
                get() {
                    return this.$store.getters['CategoriesStore/selectedCategoriesYourDataNames']
                }
            },
            CategoriesSelectedBenchmark: {
                get() {
                    return this.$store.getters['CategoriesStore/selectedCategoriesBenchmarkNames']
                }
            },
            CategoriesSelectedSegment: {
                get() {
                    return this.$store.getters['CategoriesStore/selectedCategoriesSegmentNames']
                }
            },
            modelScoreRadios: {
                get() {
                    return this.$store.state.YourDataStore.modelScoreRadios;
                },
                set(newVal) {
                    //this.$store.dispatch('Categories/setmodelYourDataFilters', newVal);
                    this.$store.state.YourDataStore.modelScoreRadios = newVal;
                }
            },
        },
        methods: {
            ...mapActions('YourDataStore', [
                'updateChart'
            ]),
            clearAllYourDataFilters() {
                this.filtersUpdated = false;
                this.$store.dispatch('CategoriesStore/resetYourDataFilters')
                this.Loading = true;
                this.$store.dispatch('YourDataStore/getChartDataBOB')
                    .then(() => {
                        this.Loading = false;
                    })
                    .catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
            clearAllBenchmarkFilters() {
                this.filtersUpdated = false;
                this.$store.dispatch('CategoriesStore/resetBenchmarkFilters')
                this.Loading = true;
                this.$store.dispatch('YourDataStore/getChartDataBOB')
                    .then(() => {
                        this.Loading = false;
                    })
                    .catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
            clearAllSegmentFilters() {
                this.filtersUpdated = false;
                this.$store.dispatch('CategoriesStore/resetSegmentFilters')
                this.Loading = true;
                this.$store.dispatch('YourDataStore/getChartDataBOB')
                    .then(() => {
                        this.Loading = false;
                    })
                    .catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
        },
        mounted() {
            this.Loading = true;
            this.$store.dispatch('UserManagementStore/getUserClientDetails').then(() => {
                this.$store.dispatch('CategoriesStore/getAllCategories')
                    .then(() => {
                        this.$store.dispatch('YourDataStore/getChartDataBOB')
                            .then(() => {
                                this.Loading = false;
                            })
                            .catch(error => {
                                this.Loading = false;
                                this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                                console.log(error);
                            });
                    })
                    .catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                        console.log(error);
                    });
            }).catch(error => {
                this.Loading = false;
                this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
            })
        }
    };
</script>
<style>
    .chart-container {
        position: relative;
        margin: auto;
        height: 80vh;
        width: 80vw;
    }
</style>